import React, {Component} from 'react'
import './usa.scss'
import {baiduTongJI, checkPhone} from "../../api/utils"
import api from "../../api/api"
import Footer from "../components/footer"
class Usa extends Component {
	state={
		name:'',
		mobile:'',
		city:'',
		intended_major:'',
		education:'',
		in_country:''
	}
	submit=async ()=>{
		let {name,mobile,city,intended_major,education,in_country}=this.state
		if (!name){
			layer.msg('姓名不能为空！')
			return
		}
		if (!checkPhone(mobile)){
			layer.msg('手机号格式不正确！')
			return
		}
		let res=await api.post('/form/study-abroad',{name,mobile,city,intended_major,education,in_country},true)
		this.setState({
			name:'',
			mobile:'',
			city:'',
			intended_major:'',
			education:'',
			in_country:''
		})
		layer.msg('提交成功')
		// console.log(res)
	}
	setValue=(key,val)=>{
		this.setState({
			[key]:val
		})
	}
	initSwiper=()=>{
		let slidesPerView=4
		if ($(window).width()<=768){
			slidesPerView=1
		}
		this.mySwiper = new Swiper('.mc_anli', {
			loop: true,
			slidesPerView:slidesPerView,
			spaceBetween:20,
			autoplay:true,
			pagination: {
				el: '.mc_pagination',
			},
			navigation: {
				nextEl: '.mc_next',
				prevEl: '.mc_prev',
			},
		})
	}
	openbaidusq=()=>{
		$('#nb_invite_ok').click()
	}
	componentDidMount() {
		document.getElementById('root').style.paddingTop=0
		document.getElementsByTagName('body')[0].style.setProperty("padding-top","0px","important")
		this.initSwiper()
		// baiduTongJI()
	}
	render() {
		return (
			<div>
				<div className={'usa'}>
					<div className={'ban usabanWrap'}>
						<img src={require('../../static/images/usaBan.png')} alt=""/>
						<img className={'usalogo'} src={require('../../static/images/phoneLogo.png')} alt=""/>
					</div>
					<div className={'usaContent'}>
						<div className={'usaModule usaTop30'}>
							<img className={'usaBagDian'} src={require('../../static/images/usa-dian.png')} alt=""/>
							<div className={'usaBox'}>
								<div className={'usaTitle'}>
									<img src={require('../../static/images/usa-icon-shu.png')} className={'usaiconshu'} alt=""/>
									<div className={'usaTitleText'}>
										TOP30名校计划 助力名校梦想
									</div>
								</div>
								<div className={'usaText'}>
									专注美国TOP30申请，旨在为高中志向美国前30的优秀学生提供考培计划、活动规划和留学申请等美国高端留学解决方案。引领学生全面认识自我，提升综合能力，并培养真正的国际化高素质人才。
								</div>
							</div>
						</div>
						<div className={'usaModule'}>
							<div className={'usaBox'}>
								<div className={'usaTitle'}>
									<img src={require('../../static/images/usa-icon-shu.png')} className={'usaiconshu'} alt=""/>
									<div className={'usaTitleText'}>
										师资团队
									</div>
								</div>
								<div className={'usaText'}>
									每一位资深顾问在留学行业从业经验均在7年以上，成功帮助众多学生拿到哈佛大学、哥伦比亚大学、芝加哥大学、宾夕法尼亚大学、康奈尔大学、加州大学伯克利分校等美国名校录取。老师们善于提炼学生亮点，从在校成绩、实习、科研等方面全方位提升学生背景，制定专属的个性化留学规划方案。
								</div>
								<div className={'usaTeachers'}>
									<div className={'usaTeacherItem'}>
										<img src={require('../../static/images/usa-laoshi1.jpg')} className={'usaTeacherImg'} alt=""/>
										<div className={'usaTeacherTitle'}>咨询总监</div>
									</div>
									<div className={'usaTeacherItem'}>
										<img src={require('../../static/images/usa-laoshi2.jpg')} className={'usaTeacherImg'} alt=""/>
										<div className={'usaTeacherTitle'}>名校申请专家</div>
									</div>
									<div className={'usaTeacherItem'}>
										<img src={require('../../static/images/usa-laoshi3.jpg')} className={'usaTeacherImg'} alt=""/>
										<div className={'usaTeacherTitle'}>资深升学指导</div>
									</div>
									<div className={'usaTeacherItem'}>
										<img src={require('../../static/images/usa-laoshi4.jpg')} className={'usaTeacherImg'} alt=""/>
										<div className={'usaTeacherTitle'}>留学主顾问</div>
									</div>
									<div className={'usaTeacherItem'}>
										<img src={require('../../static/images/usa-laoshi5.jpg')} className={'usaTeacherImg'} alt=""/>
										<div className={'usaTeacherTitle'}>高级留学规划师</div>
									</div>
									<div className={'usaTeacherItem'}>
										<img src={require('../../static/images/usa-laoshi6.jpg')} className={'usaTeacherImg'} alt=""/>
										<div className={'usaTeacherTitle'}>安生教育顾问</div>
									</div>
									<div className={'usaTeacherItem'}>
										<img src={require('../../static/images/usa-laoshi7.jpg')} className={'usaTeacherImg'} alt=""/>
										<div className={'usaTeacherTitle'}>中期规划师</div>
									</div>
									<div className={'usaTeacherItem'}>
										<img src={require('../../static/images/usa-laoshi8.jpg')} className={'usaTeacherImg'} alt=""/>
										<div className={'usaTeacherTitle'}>美籍顾问</div>
									</div>
								</div>
								<div className={'usaTeacherBottom'}>
									<div className={'usaTeacherBottomLeft'}>
										<img className={'usaTeacherBottomLeftImg'} src={require('../../static/images/usa-img02.jpg')} alt=""/>
										<div className={'usaTeacherBottomLeftText'}>
											资深导师团队 <br/>
											一对一规划指导
										</div>
									</div>
									<div className={'usaTeacherBottomRight'}>
										<div className={'usaTeacherBottomRightItem'}>
											强大师资阵容，导师团队服务模式
										</div>
										<div className={'usaTeacherBottomRightItem'}>
											建立学生个人数据库，把控学生学习情况，及学生各类活动、申请信息
										</div>
										<div className={'usaTeacherBottomRightItem'}>
											一对一背景、活动提升方案指导
										</div>
										<div className={'usaTeacherBottomRightItem'}>
											留学时间轴规划，根据学生实际操作情况实时调整
										</div>
										<div className={'usaTeacherBottomRightItem'}>
											结合学生兴趣爱好、特长等合理分析，指导学生专业方向选择
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className={'usaModule'}>
							<div className={'usaBox'}>
								<div className={'usaRule'}>
									<div className={'usaRuleLeft'}>
										<div>
											<div className={'usaTitle'}>
												<img src={require('../../static/images/usa-icon-shu.png')} className={'usaiconshu'} alt=""/>
												<div className={'usaTitleText'}>
													美国藤校高端规划
												</div>
											</div>
											<div className={'usaText'}>
												美丞藤校规划服务旨在帮助优秀的学生更精准的进入全美TOP10名校，利用丰富的海外资源打造学生与梦校招生官、学长交流平台，让学生在日趋激烈的竞争中适中把握先机。
											</div>
										</div>
										<div>
											<div className={'usaTitle'}>
												<img src={require('../../static/images/usa-icon-shu.png')} className={'usaiconshu'} alt=""/>
												<div className={'usaTitleText'}>
													项目优势
												</div>
											</div>
											<div className={'usaText'}>
												助力意向TOP10的学生将进入直接锁定排名的大学。围绕美国TOP10名校录取的特点，全方位打造菁英学子的提升规划，不再简单的参加背景提升活动，而是打造属于学生的活动，去获取打动世界顶尖大学的素材。名师团队AP培训，帮助学生斩获高分，直击名校。
											</div>
										</div>
									</div>
									<div className={'usaRuleRight'}>
										<img className={'usaRuleImg'} src={require('../../static/images/usa-img01.jpg')} alt=""/>
									</div>
								</div>
							</div>
						</div>
						<div className={'usaModule'}>
							<img className={'usaBagDian'} src={require('../../static/images/usa-dian.png')} alt=""/>
							<div className={'usaBox'}>
								<div className={'usaTitle'} style={{border:"none"}}>
									<img src={require('../../static/images/usa-icon-shu.png')} className={'usaiconshu'} alt=""/>
									<div className={'usaTitleText'}>
										选择美丞留学的优势
									</div>
								</div>
								<div className={'usaYoushiWrap'}>
									<div className={'usaYoushi'}>
										<div className={'usaYoushiText'}>斯坦福大学、杜克大学，约翰霍普金斯大学，康奈尔大学， 罗切斯特大学，乔治华盛顿大学等顶尖名校合作项目，为优秀学生创造高端平台，一流路线。大部分美丞的学生进入美国前50强名校。
										</div>
										<div className={'usabag'}>
											名校合作 <br/>
											高端品牌
										</div>
									</div>
									<div className={'usaYoushi'}>
										<div className={'usaYoushiText'}>针对不同学生的留学需求，美丞留学将提供全方位、个性化、多层次的留学项目供学生选择。让每一位选择美丞留学的学生都能做到理性留学，快乐深造。
										</div>
										<div className={'usabag'}>
											项目多样<br/>
											出国无忧
										</div>
									</div>
									<div className={'usaYoushi'}>
										<div className={'usaYoushiText'}>兼顾院校品质和学生潜力，为学生量身定制留学方案，提供美国各校合作联盟的丰富资源与院校面对面的多样机会，让学生近距离了解海外求学信息。长期的从业经验、大量的案例积累和历年参与海外升学委员会招生官的大学申请培训，使我们能够精准把握美国本科院校的申请要求，更全面地规划留学之路。
										</div>
										<div className={'usabag'}>
											专业规划<br/>
											全程跟踪
										</div>
									</div>
									<div className={'usaYoushi'}>
										<div className={'usaYoushiText'}>中外籍顾问、文书团队服务学生，秉承高度的责任感和同理心，充分利用外籍顾问的教育背景和申请经验，在申请过程中不断发掘学生的申请亮点，使学生不断地实现自我认识和自我提升。
										</div>
										<div className={'usabag'}>
											中外团队<br/>
											细心专业
										</div>
									</div>
									<div className={'usaYoushi'}>
										<div className={'usaYoushiText'}>我们专业的顾问都拥有多年在国外留学或工作的经历。我们会以讲座，实例讲解以及经验分享会等形式对即将出国的学生及家长进行行前培训，让他们全方位了解并提早适应陌生的异国学习和生活环境。
										</div>
										<div className={'usabag'}>
											行前培训 <br/>
											完善周到
										</div>
									</div>
									<div className={'usaYoushi'}>
										<div className={'usaYoushiText'}>学生成功奔赴海外，并不意味着美丞留学服务的终止，为了帮助学生融入新的环境，除提供当地住宿安排、协助接机、金融服务推荐、建立全球同学会外，我们还定期进行电话回访，与学校沟通协调，学生续签指导等后续服务。
										</div>
										<div className={'usabag'}>
											延续服务<br/>
											温馨至诚
										</div>
									</div>
									<div className={'usaYoushi'}>
										<div className={'usaYoushiText'}>我们将会为我们的学生提供海外就业指导和安排。对于刚毕业想回国工作的学子，可以通过我们的芝麻驿站，线上参与宣讲招聘会，与知名企业高管对话，获得第一手招聘信息。目前我们与众多世界院校，数百家高端企业合作，服务学生人数逾300万。
										</div>
										<div className={'usabag'}>
											海外实习 <br/>
											海归招聘
										</div>
									</div>
								</div>
								<div className={'usaTitle'}>
									<img src={require('../../static/images/usa-icon-shu.png')} className={'usaiconshu'} alt=""/>
									<div className={'usaTitleText'}>
										成功案例
									</div>
								</div>
								<div className={'mc_anli swiper-container'}>
									<div className={'usaAnli swiper-wrapper'}>
										<div className={'usaAnliItem swiper-slide'}>
											<img  className={'usaAnliItemImg'} src={require('../../static/images/usa-anli1.jpg')} alt=""/>
											<div className={'usaAnliItemText'}>C同学 TOEFL 103，SAT：1450 佛罗里达大学</div>
										</div>
										<div className={'usaAnliItem swiper-slide'}>
											<img  className={'usaAnliItemImg'} src={require('../../static/images/usa-anli2.jpg')} alt=""/>
											<div className={'usaAnliItemText'}>C同学 TOEFL 112  SAT 1450 杜克大学</div>
										</div>
										<div className={'usaAnliItem swiper-slide'}>
											<img  className={'usaAnliItemImg'} src={require('../../static/images/usa-anli3.jpg')} alt=""/>
											<div className={'usaAnliItemText'}>G同学 TOEFL 105+  SAT 1450 纽约大学</div>
										</div>
										<div className={'usaAnliItem swiper-slide'}>
											<img  className={'usaAnliItemImg'} src={require('../../static/images/usa-anli4.jpg')} alt=""/>
											<div className={'usaAnliItemText'}>L同学 TOEFL 96  SAT 1350 雪城大学</div>
										</div>
										<div className={'usaAnliItem swiper-slide'}>
											<img  className={'usaAnliItemImg'} src={require('../../static/images/usa-anli5.jpg')} alt=""/>
											<div className={'usaAnliItemText'}>L同学 TOEFL 102 加州大学圣巴巴拉分校</div>
										</div>
										<div className={'usaAnliItem swiper-slide'}>
											<img  className={'usaAnliItemImg'} src={require('../../static/images/usa-anli6.jpg')} alt=""/>
											<div className={'usaAnliItemText'}>S同学 TOEFL 110、SAT 1423 纽约大学</div>
										</div>
										<div className={'usaAnliItem swiper-slide'}>
											<img  className={'usaAnliItemImg'} src={require('../../static/images/usa-anli7.jpg')} alt=""/>
											<div className={'usaAnliItemText'}>Y同学 雅思6.9 加州戴维斯大学</div>
										</div>
										<div className={'usaAnliItem swiper-slide'}>
											<img  className={'usaAnliItemImg'} src={require('../../static/images/usa-anli8.jpg')} alt=""/>
											<div className={'usaAnliItemText'}>Z同学 TOEFL 80 圣地亚哥大学</div>
										</div>
										<div className={'usaAnliItem swiper-slide'}>
											<img  className={'usaAnliItemImg'} src={require('../../static/images/usa-anli9.jpg')} alt=""/>
											<div className={'usaAnliItemText'}>Z同学 TOEFL 95  SAT 1350 雪城大学</div>
										</div>
										{/*<div className={'usaAnliItem swiper-slide'}>*/}
										{/*	<img  className={'usaAnliItemImg'} src={require('../../static/images/usa-anli10.jpg')} alt=""/>*/}
										{/*	<div className={'usaAnliItemText'}>Z同学 雅思7.3 爱丁堡大学</div>*/}
										{/*</div>*/}
									</div>
									<div className="mc_pagination swiper-pagination"></div>
									<div className="mc_prev swiper-button-prev"></div>
									<div className="mc_next swiper-button-next"></div>
								</div>
								<div className={'usaTitle'}>
									<img src={require('../../static/images/usa-icon-shu.png')} className={'usaiconshu'} alt=""/>
									<div className={'usaTitleText'}>
										申请条件
									</div>
								</div>
								<div className={'usaApply'}>
									<div onClick={this.openbaidusq} className={'usaApplyItem'}>
										<img className={'usaApplyItemImg'} src={require('../../static/images/usaApply01.jpg')} alt=""/>
										<div className={'usaApplyItemText'}>
											<div className={'usaApplyTitle'}>重点院校</div>
											<div className={'usaApplySlogan'}>著名高中</div>
											<div className={'usaApplyLine'}/>
											<div className={'usaApplyTopics'}>年级排名的重要性</div>
										</div>
									</div>
									<div onClick={this.openbaidusq} className={'usaApplyItem'}>
										<img className={'usaApplyItemImg'} src={require('../../static/images/usaApply02.jpg')} alt=""/>
										<div className={'usaApplyItemText'}>
											<div className={'usaApplyTitle'}>GPA</div>
											<div className={'usaApplySlogan'}>GPA需要90+/100</div>
											<div className={'usaApplyLine'}/>
											<div className={'usaApplyTopics'}>GPA不足的弥补</div>
										</div>
									</div>
									<div onClick={this.openbaidusq} className={'usaApplyItem'}>
										<img className={'usaApplyItemImg'} src={require('../../static/images/usaApply03.jpg')} alt=""/>
										<div className={'usaApplyItemText'}>
											<div className={'usaApplyTitle'}>TOEFL</div>
											<div className={'usaApplySlogan'}>TOEFL需要90+</div>
											<div className={'usaApplyLine'}/>
											<div className={'usaApplyTopics'}>点击了解详情</div>
										</div>
									</div>
									<div onClick={this.openbaidusq} className={'usaApplyItem'}>
										<img className={'usaApplyItemImg'} src={require('../../static/images/usaApply05.jpg')} alt=""/>
										<div className={'usaApplyItemText'}>
											<div className={'usaApplyTitle'}>SAT</div>
											<div className={'usaApplySlogan'}>SAT需要1250+</div>
											<div className={'usaApplyLine'}/>
											<div className={'usaApplyTopics'}>点击了解详情</div>
										</div>
									</div>
									<div onClick={this.openbaidusq} className={'usaApplyItem'}>
										<img className={'usaApplyItemImg'} src={require('../../static/images/usaApply06.jpg')} alt=""/>
										<div className={'usaApplyItemText'}>
											<div className={'usaApplyTitle'}>特长优先</div>
											<div className={'usaApplySlogan'}>有艺术、体育、数学特长等优先考虑</div>
											<div className={'usaApplyLine'}/>
											<div className={'usaApplyTopics'}>如何展示特长</div>
										</div>
									</div>
									<div onClick={this.openbaidusq} className={'usaApplyItem'}>
										<img className={'usaApplyItemImg'} src={require('../../static/images/usaApply04.jpg')} alt=""/>
										<div className={'usaApplyItemText'}>
											<div className={'usaApplyTitle'}>竞赛奖项</div>
											<div className={'usaApplySlogan'}>获过国际竞赛等奖项的优先考虑</div>
											<div className={'usaApplyLine'}/>
											<div className={'usaApplyTopics'}>需要参加哪些活动</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className={'usaModule'}>
							<img className={'usaBagDian'} src={require('../../static/images/usa-dian.png')} alt=""/>
							<div className={'usaBox'}>
								<div className={'usaTitle'}>
									<img src={require('../../static/images/usa-icon-shu.png')} className={'usaiconshu'} alt=""/>
									<div className={'usaTitleText'}>
										实力展示
									</div>
								</div>
								<div className={'usaPower'}>
									<table cellSpacing={0} cellPadding={0}>
										<tbody>
										<tr>
											<th>USNEWS美国排名</th>
											<th>学校名称</th>
											<th>录取人数</th>
										</tr>
										<tr>
											<td>3</td>
											<td>哥伦比亚大学 Columbia University in the City of New York</td>
											<td>1</td>
										</tr>
										<tr>
											<td>4</td>
											<td>麻省理工学院 Massachusetts Institute of Technology</td>
											<td>1</td>
										</tr>
										<tr>
											<td>4</td>
											<td>耶鲁大学 Yale University</td>
											<td>1</td>
										</tr>
										<tr>
											<td>6</td>
											<td>芝加哥大学 The University of Chicago</td>
											<td>1</td>
										</tr>
										<tr>
											<td>9</td>
											<td>约翰霍普金斯大学 Johns Hopkins University</td>
											<td>2</td>
										</tr>
										<tr>
											<td>13</td>
											<td>达特茅斯学院 Dartmouth College</td>
											<td>1</td>
										</tr>
										<tr>
											<td>14</td>
											<td>范德堡大学 Vanderbilt University</td>
											<td>3</td>
										</tr>
										<tr>
											<td>16</td>
											<td>莱斯大学 Rice University</td>
											<td>2</td>
										</tr>
										<tr>
											<td>20</td>
											<td>加州大学洛杉矶分校 University of California, Los Angeles</td>
											<td>7</td>
										</tr>
										<tr>
											<td>21</td>
											<td>埃默里大学 Emory University</td>
											<td>2</td>
										</tr>
										<tr>
											<td>22</td>
											<td>加州大学伯克利分校 University of California, Berkeley</td>
											<td>4</td>
										</tr>
										<tr>
											<td>24</td>
											<td>南加州大学 University of Southern California</td>
											<td>3</td>
										</tr>
										<tr>
											<td>26</td>
											<td>卡耐基梅隆大学 Carnegie Mellon University</td>
											<td>3</td>
										</tr>
										<tr>
											<td>26</td>
											<td>弗吉尼亚大学 University of Virginia</td>
											<td>6</td>
										</tr>
										<tr>
											<td>28</td>
											<td>北卡罗来纳大学教堂山分校 University of North Carolina at Chapel Hill</td>
											<td>10</td>
										</tr>
										<tr>
											<td>30</td>
											<td>纽约大学 New York University</td>
											<td>19</td>
										</tr>
										<tr>
											<td>30</td>
											<td>佛罗里达大学 University of Florida</td>
											<td>6</td>
										</tr>
										<tr>
											<td>30</td>
											<td>加州大学圣芭芭拉分校 University of California, Santa Barbara</td>
											<td>82</td>
										</tr>
										<tr>
											<td>34</td>
											<td>罗切斯特大学 University of Rochester</td>
											<td>6</td>
										</tr>
										<tr>
											<td>35</td>
											<td>佐治亚理工学院 Georgia Institute of Technology</td>
											<td>4</td>
										</tr>
										<tr>
											<td>35</td>
											<td>加州大学欧文分校 University of California, Irvine</td>
											<td>58</td>
										</tr>
										<tr>
											<td>35</td>
											<td>加州大学圣地亚哥分校 University of California, San Diego</td>
											<td>27</td>
										</tr>
										<tr>
											<td>39</td>
											<td>威廉玛丽学院 College of William & Mar</td>
											<td>4</td>
										</tr>
										<tr>
											<td>39</td>
											<td>加州大学戴维斯分校 University of California, Davis</td>
											<td>75</td>
										</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
						<div className={'usaModule'}>
							<div className={'usaBox'}>
								<div className={'usaTitle'}>
									<img src={require('../../static/images/usa-icon-shu.png')} className={'usaiconshu'} alt=""/>
									<div className={'usaTitleText'}>
										办理流程
									</div>
								</div>
								<div className={'usaStep'}>
									<div className={'usaStepContent'}>
										<div className={'usaStepImgWrap'}>
											<img className={'usaStepImg'} src={require('../../static/images/lcbl1.png')} alt=""/>
										</div>
										<div className={'usaStepText'}>留学申请</div>
									</div>
									<img className={'usaArrow'} src={require('../../static/images/usaArrow.png')} alt=""/>
									<div className={'usaStepContent'}>
										<div className={'usaStepImgWrap'}>
											<img className={'usaStepImg'} src={require('../../static/images/lcbl2.png')} alt=""/>
										</div>
										<div className={'usaStepText'}>选校规划</div>
									</div>
									<img className={'usaArrow'} src={require('../../static/images/usaArrow.png')} alt=""/>
									<div className={'usaStepContent'}>
										<div className={'usaStepImgWrap'}>
											<img className={'usaStepImg'} src={require('../../static/images/lcbl4.png')} alt=""/>
										</div>
										<div className={'usaStepText'}>院校申请</div>
									</div>
									<img className={'usaArrow'} src={require('../../static/images/usaArrow.png')} alt=""/>
									<div className={'usaStepContent'}>
										<div className={'usaStepImgWrap'}>
											<img className={'usaStepImg'} src={require('../../static/images/lcbl5.png')} alt=""/>
										</div>
										<div className={'usaStepText'}>文书创造</div>
									</div>
									<img className={'usaArrow'} src={require('../../static/images/usaArrow.png')} alt=""/>
									<div className={'usaStepContent'}>
										<div className={'usaStepImgWrap'}>
											<img className={'usaStepImg'} src={require('../../static/images/lcbl6.png')} alt=""/>
										</div>
										<div className={'usaStepText'}>面试指导</div>
									</div>
									<img className={'usaArrow'} src={require('../../static/images/usaArrow.png')} alt=""/>
									<div className={'usaStepContent'}>
										<div className={'usaStepImgWrap'}>
											<img className={'usaStepImg'} src={require('../../static/images/lcbl7.png')} alt=""/>
										</div>
										<div className={'usaStepText'}>签证办理</div>
									</div>
									<img className={'usaArrow'} src={require('../../static/images/usaArrow.png')} alt=""/>
									<div className={'usaStepContent'}>
										<div className={'usaStepImgWrap'}>
											<img className={'usaStepImg'} src={require('../../static/images/lcbl8.png')} alt=""/>
										</div>
										<div className={'usaStepText'}>后续服务</div>
									</div>
									<div className={'usaStepContent usaStepContentZhan'}>
										<div className={'usaStepImgWrap'}>

										</div>
									</div>
								</div>
							</div>
						</div>
						<div className={'usaModule'} id={'form'}>
							<div className={'usaTitle'}>
								<div className={'usaTitleText usaTextCenter'}>
									免费留学评估
								</div>
							</div>
							<div className={'usaForm'}>
								<div className={'usaFormItem'}>
									<div className={'usaFormLabel'}>姓名 <span>*</span> </div>
									<input className={'usaInp'} value={this.state.name} onChange={(e)=>{this.setValue('name',e.target.value)}} type="text"/>
								</div>
								<div className={'usaFormItem'}>
									<div className={'usaFormLabel'}>手机 <span>*</span> </div>
									<input className={'usaInp'} value={this.state.mobile} onChange={(e)=>{this.setValue('mobile',e.target.value)}} type="text"/>
								</div>
								<div className={'usaFormItem'}>
									<div className={'usaFormLabel'}>所在城市</div>
									<input className={'usaInp'} value={this.state.city} onChange={(e)=>{this.setValue('city',e.target.value)}} type="text"/>
								</div>
								<div className={'usaFormItem'}>
									<div className={'usaFormLabel'}>意向专业</div>
									<input className={'usaInp'} value={this.state.intended_major} onChange={(e)=>{this.setValue('intended_major',e.target.value)}} type="text"/>
								</div>
								<div className={'usaFormItem'}>
									<div className={'usaFormLabel'}>教育阶段</div>
									<select className={'usaInp'} value={this.state.education}
									        onChange={(e)=>{
										        e.persist();
										        this.setValue('education',e.target.value)
									        }} name="" id="">
										<option value="" disabled={true}>请选择</option>
										<option value="高中">高中</option>
										<option value="大专">大专</option>
										<option value="本科">本科</option>
										<option value="硕士">硕士</option>
									</select>
								</div>
								<div className={'usaFormItem'}>
									<div className={'usaFormLabel'}>意向国家</div>
									<select value={this.state.in_country}  onChange={(e,v)=>{
										e.persist();
										this.setValue('in_country',e.target.value)
									}} className={'usaInp'} name="" id="">
										<option value="" disabled={true}>请选择</option>
										<option value="美国">美国</option>
										<option value="英国">英国</option>
										<option value="加拿大">加拿大</option>
										<option value="澳洲">澳洲</option>
										<option value="新西兰">新西兰</option>
										<option value="香港">香港</option>
										<option value="新加披">新加披</option>
										<option value="其他">其他</option>
									</select>
								</div>
							</div>
							<div className={'usaFormButton'} onClick={this.submit}>
								提交
							</div>
						</div>
					</div>
					<img className={'usaBgBottom'} src={require('../../static/images/usa-bg-bottom.png')} alt=""/>
				</div>
				<Footer/>
			</div>
		)
	}
}

export default Usa